import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "card card-default custom-card-height" }
const _hoisted_3 = { class: "card-header feature-header" }
const _hoisted_4 = { class: "row g-2" }
const _hoisted_5 = { class: "col-auto me-auto" }
const _hoisted_6 = { class: "col-auto" }
const _hoisted_7 = { class: "col-auto" }
const _hoisted_8 = { class: "card-body p-2" }
const _hoisted_9 = { class: "card-body-grid" }
const _hoisted_10 = {
  class: "btn-group actions-row",
  role: "group",
  "aria-label": "Basic example"
}
const _hoisted_11 = ["onClick"]
const _hoisted_12 = ["onClick"]
const _hoisted_13 = ["onClick"]
const _hoisted_14 = {
  class: "modal fade",
  id: "subscriptionModal",
  role: "dialog"
}
const _hoisted_15 = { class: "modal-dialog modal-lg" }
const _hoisted_16 = { class: "modal-content" }
const _hoisted_17 = { class: "modal-header" }
const _hoisted_18 = { class: "modal-title" }
const _hoisted_19 = {
  class: "modal fade",
  id: "subscriptionModuleSyncModal",
  role: "dialog"
}
const _hoisted_20 = { class: "modal-dialog modal-lg" }
const _hoisted_21 = { class: "modal-content" }
const _hoisted_22 = { class: "modal-header" }
const _hoisted_23 = { class: "modal-title" }
const _hoisted_24 = { class: "modal-body" }
const _hoisted_25 = { class: "table table-sm table-bordered" }
const _hoisted_26 = { class: "col-6" }
const _hoisted_27 = { class: "col-6" }
const _hoisted_28 = { class: "col-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CardTitleComponent = _resolveComponent("CardTitleComponent")!
  const _component_SearchComponent = _resolveComponent("SearchComponent")!
  const _component_e_column = _resolveComponent("e-column")!
  const _component_ejs_chiplist = _resolveComponent("ejs-chiplist")!
  const _component_e_columns = _resolveComponent("e-columns")!
  const _component_ejs_grid = _resolveComponent("ejs-grid")!
  const _component_ConfirmComponent = _resolveComponent("ConfirmComponent")!
  const _component_RegisterModalComponent = _resolveComponent("RegisterModalComponent")!
  const _component_ejs_checkbox = _resolveComponent("ejs-checkbox")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_CardTitleComponent)
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_SearchComponent, {
                modelValue: _ctx.searchText,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchText) = $event)),
                onSearch: _ctx.onSearch,
                onClear: _ctx.clearSearch
              }, null, 8, ["modelValue", "onSearch", "onClear"])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("a", {
                class: "btn btn-outline-primary",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.open(true)))
              }, [
                _cache[5] || (_cache[5] = _createElementVNode("i", { class: "fas fa-plus me-1" }, null, -1)),
                _createTextVNode(_toDisplayString(_ctx.$t('addNew')), 1)
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_ejs_grid, {
              ref: "gridsubscription",
              dataSource: _ctx.data,
              allowPaging: true,
              allowResizing: true,
              pageSettings: _ctx.pageSettings,
              locale: _ctx.locale,
              rowHeight: 38,
              allowSorting: true,
              height: "100%",
              searchSettings: _ctx.searchOptions,
              dataStateChange: _ctx.dataStateChange
            }, {
              default: _withCtx(() => [
                _createVNode(_component_e_columns, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_e_column, {
                      headerText: _ctx.$t('organization') + ' ' + _ctx.$t('name'),
                      field: "OrganizationName",
                      width: "100"
                    }, null, 8, ["headerText"]),
                    _createVNode(_component_e_column, {
                      headerText: _ctx.$t('server') + ' ' + _ctx.$t('name'),
                      field: "ServerName",
                      width: "80"
                    }, null, 8, ["headerText"]),
                    _createVNode(_component_e_column, {
                      headerText: _ctx.$t('database') + ' ' + _ctx.$t('name'),
                      field: "dbName",
                      width: "100"
                    }, null, 8, ["headerText"]),
                    _createVNode(_component_e_column, {
                      headerText: _ctx.$t('subscriber') + ' ' + _ctx.$t('type'),
                      field: "SubscriberType",
                      width: "100"
                    }, null, 8, ["headerText"]),
                    _createVNode(_component_e_column, {
                      headerText: _ctx.$t('modules'),
                      field: "modules",
                      allowSorting: false,
                      template: 'moduleTemplate'
                    }, {
                      moduleTemplate: _withCtx(({ data }) => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.modules, (chipItem, index) => {
                          return (_openBlock(), _createBlock(_component_ejs_chiplist, {
                            id: 'chip' + index,
                            text: chipItem.name
                          }, null, 8, ["id", "text"]))
                        }), 256))
                      ]),
                      _: 1
                    }, 8, ["headerText"]),
                    _createVNode(_component_e_column, {
                      headerText: _ctx.$t('actions'),
                      width: "90",
                      textAlign: "Center",
                      template: 'actionTemplate'
                    }, {
                      actionTemplate: _withCtx(({ data }) => [
                        _createElementVNode("div", _hoisted_10, [
                          _createElementVNode("a", {
                            href: "javascript:void(0)",
                            class: "ms-2 action-link",
                            title: "Sync Activation",
                            onClick: ($event: any) => (_ctx.commandClick('Sync activation', data))
                          }, [...(_cache[6] || (_cache[6] = [
                            _createElementVNode("i", {
                              class: "e-repeat e-icons",
                              style: {"font-size":"0.76em"}
                            }, null, -1)
                          ]))], 8, _hoisted_11),
                          _createElementVNode("a", {
                            href: "javascript:void(0)",
                            class: "ms-2 action-link action-edit",
                            title: "Edit",
                            onClick: ($event: any) => (_ctx.commandClick('Edit', data))
                          }, [...(_cache[7] || (_cache[7] = [
                            _createElementVNode("i", {
                              class: "e-edit e-icons",
                              style: {"font-size":"0.76em"}
                            }, null, -1)
                          ]))], 8, _hoisted_12),
                          _createElementVNode("a", {
                            href: "javascript:void(0)",
                            class: "ms-2 action-link action-delete",
                            title: "Delete",
                            onClick: ($event: any) => (_ctx.commandClick('Delete', data))
                          }, [...(_cache[8] || (_cache[8] = [
                            _createElementVNode("i", {
                              class: "e-delete e-icons",
                              style: {"font-size":"0.76em"}
                            }, null, -1)
                          ]))], 8, _hoisted_13)
                        ])
                      ]),
                      _: 1
                    }, 8, ["headerText"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["dataSource", "pageSettings", "locale", "searchSettings", "dataStateChange"])
          ]),
          _createVNode(_component_ConfirmComponent, {
            title: _ctx.confirmTitle,
            "is-subscription": true,
            "subscription-delete-title": _ctx.$t('subscriptionDeleteConfirm'),
            onYes: _ctx.commandConfirm
          }, null, 8, ["title", "subscription-delete-title", "onYes"])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_14, [
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("h4", _hoisted_18, _toDisplayString(_ctx.$t('customer')), 1),
            _createElementVNode("button", {
              type: "button",
              class: "close",
              "data-bs-dismiss": "modal",
              "aria-label": "Close",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.close('subscriptionModal')))
            }, [...(_cache[9] || (_cache[9] = [
              _createElementVNode("span", { "aria-hidden": "true" }, "×", -1)
            ]))])
          ]),
          _createVNode(_component_RegisterModalComponent, {
            "-is-subscription": true,
            "-is-update": _ctx.isUpdate,
            form: _ctx.form
          }, null, 8, ["-is-update", "form"])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_19, [
      _createElementVNode("div", _hoisted_20, [
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("div", _hoisted_22, [
            _createElementVNode("h4", _hoisted_23, _toDisplayString(_ctx.$t('syncActivation')) + " - (" + _toDisplayString(_ctx.syncConfigurationForm.organizationName) + ") ", 1),
            _createElementVNode("button", {
              type: "button",
              class: "close",
              "data-bs-dismiss": "modal",
              "aria-label": "Close",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.close('subscriptionModuleSyncModal')))
            }, [...(_cache[10] || (_cache[10] = [
              _createElementVNode("span", { "aria-hidden": "true" }, "×", -1)
            ]))])
          ]),
          _createElementVNode("div", _hoisted_24, [
            _createElementVNode("table", _hoisted_25, [
              _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", _hoisted_26, _toDisplayString(_ctx.$t('module')), 1),
                  _cache[11] || (_cache[11] = _createElementVNode("th", { class: "col-6" }, null, -1))
                ])
              ]),
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.syncConfigurationForm.modules, (module, index) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: module.id
                  }, [
                    _createElementVNode("td", _hoisted_27, _toDisplayString(module.name), 1),
                    _createElementVNode("td", _hoisted_28, [
                      _createVNode(_component_ejs_checkbox, {
                        id: 'module' + index,
                        modelValue: module.isSyncActive,
                        "onUpdate:modelValue": ($event: any) => ((module.isSyncActive) = $event),
                        onChange: ($event: any) => (_ctx.onSyncStatusChange(_ctx.syncConfigurationForm.id, module))
                      }, null, 8, ["id", "modelValue", "onUpdate:modelValue", "onChange"])
                    ])
                  ]))
                }), 128))
              ])
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("input", {
      id: "subsWiseRegister",
      onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.changeEffect())),
      type: "hidden"
    }, null, 32)
  ], 64))
}